import he from 'he';
import { useState } from 'react';
import SocialList from '../SocialList/social-list';
import Down from '@components/Icons/down.svg';
const SpeakerList = ({ data = [] }) => {
	const [activeSpeaker, setActiveSpeaker] = useState(0);

	if (!data || data.length === 0) {
		return null;
	}

	const list = data.map((speaker, index) => {
		const {
			images: { small = [], large = [] },
			name = '',
			job_position: jobPosition = '',
			company = '',
			hostRole = '',
			content = '',
		} = speaker;

		const activeClass = activeSpeaker === index ? 'active' : '';

		const FullDetails = () => {
			return (
				<div className="cfs-speaker-details">
					<div className="cfs-speaker-details__left">
						{large && (
							<img
								alt={he.decode(name)}
								className={'cfs-speaker-details__image'}
								src={large[0]}
								width={large[1]}
								height={large[2]}
							/>
						)}
					</div>
					<div className="cfs-speaker-details__right">
						{name && (
							<p className="cfs-speaker-details__name">
								<span className="value">{he.decode(name)}</span>
							</p>
						)}
						{jobPosition && (
							<p className="cfs-speaker-details__position">
								<span className="value">{he.decode(jobPosition)}</span>
							</p>
						)}
						{company && (
							<p className="cfs-speaker-details__company">
								<span className="value">{he.decode(company)}</span>
							</p>
						)}
						{content && (
							<div
								className="cfs-speaker-details__content"
								dangerouslySetInnerHTML={{ __html: content }}
							/>
						)}
						<SocialList data={speaker} />
					</div>
				</div>
			);
		};

		return (
			<div key={index} className={`cfs-speaker-list-row ${activeClass}`}>
				<div
					className="cfs-speaker-list__header"
					onClick={() => setActiveSpeaker(index)}
				>
					<div className="cfs-speaker-list__left">
						<div className="cfs-speaker-avatar">
							{small && (
								<img
									alt={he.decode(name)}
									src={small[0]}
									width={small[1]}
									height={small[2]}
								/>
							)}
						</div>
					</div>
					<div className="cfs-speaker-list__right">
						<div className="cfs-speaker-short-details">
							<h4 className="cfs-speaker-short__name">
								{he.decode(name)}{' '}
								{hostRole && <small>({hostRole})</small>}
							</h4>
							<p className="cfs-speaker-short__position">
								{jobPosition && he.decode(jobPosition)} {jobPosition && company && 'at'}{' '}
								{company && he.decode(company)}
							</p>
						</div>
					</div>
					<img
						className="cfs-talk-ui-icon"
						src={Down}
						alt="Down icon"
					/>
				</div>
				{activeSpeaker === index && <FullDetails />}
			</div>
		);
	});

	return <div className="cfs-single-content-speakers">{list}</div>;
};
export default SpeakerList;
